module.exports = __webpack_public_path__ + "static/share-e0b737520824d421f9e58ca8433c274f.png";